import { mergeStyles } from "@uifabric/styling";
import { memoizeFunction } from "@uifabric/utilities";
var getClassNames = memoizeFunction(function (styles, className) {
    return {
        root: mergeStyles("dashboard-add", styles.root, className),
        editor: mergeStyles("dashboard-add-editor", styles.editor),
        actions: mergeStyles("dashboard-add-actions", styles.actions),
        action: mergeStyles("dasboard-add-action", styles.action)
    };
});
export { getClassNames };
